import { GrantsType, hasScopedPermission } from '../../../Shared/utils/auth';

export const managePaymentInformationPolicy = (grants: GrantsType) =>
  hasScopedPermission(
    grants,
    'partner',
    'policies.manage_and_process_payment_info'
  );

export const manageAutopayPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.manage_autopay');

export const enabledSweepPaymentPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.enabled_sweep_payment');
